"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.defaultSort = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = require("underscore");

var _KeywordSearchView = _interopRequireDefault(require("./KeywordSearchView"));

var _KeyboardUtils = require("../../util/KeyboardUtils");

var _SearchUtils = require("../../util/SearchUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @class Keyword Search
 * @desc A component for searching by keyword and displaying results
 *
 * @param {string} [data-id="keywordSearch"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {number} [searchBuffer=1]
 *     Sets the minimum number of characters that must be typed to trigger search
 *
 * @param {Object} [tree]
 *     An array of objects to be searched through
 *
 * @param {Search~onResultClick}
 *     Callback to be triggered when a result is clicked; passes back result properties from possibleResults
 *
 */
var defaultSort = function defaultSort(_ref) {
  var _context;

  var startsWith = (0, _startsWith.default)(_ref),
      contains = _ref.contains;

  var sort = function sort(_ref2, _ref3) {
    var a = _ref2.id;
    var b = _ref3.id;
    return a > b ? 1 : -1;
  };

  return (0, _concat.default)(_context = []).call(_context, (0, _sort.default)(startsWith).call(startsWith, sort), (0, _sort.default)(contains).call(contains, sort));
};

exports.defaultSort = defaultSort;

var KeywordSearch = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(KeywordSearch, _React$Component);

  var _super = _createSuper(KeywordSearch);

  function KeywordSearch(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, KeywordSearch);
    _this = _super.call(this, _props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "searchTree", _underscore.noop);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resultsIndex", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "createSearchAndIndex", function (props) {
      var _createSearch = (0, _SearchUtils.createSearch)(props.tree),
          _createSearch2 = (0, _slicedToArray2.default)(_createSearch, 2),
          search = _createSearch2[0],
          resultsIndex = _createSearch2[1];

      _this.searchTree = search;
      _this.resultsIndex = resultsIndex;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkForMatch", function (term) {
      var _context2;

      return (0, _sort.default)(_context2 = _this.props).call(_context2, _this.searchTree(term));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getInitialResults", function () {
      var _context3;

      return _this.props.initialResults ? (0, _map.default)(_context3 = _this.props.initialResults).call(_context3, function (id) {
        return _this.resultsIndex[id];
      }) : _this.checkForMatch("");
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_resetSearch", function () {
      return _this.setState({
        query: null,
        results: _this.getInitialResults(),
        selectedIndex: 0
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onKeyDown", function (_ref4) {
      var keyCode = _ref4.keyCode;

      if ((0, _KeyboardUtils.isArrowUp)(keyCode)) {
        _this.setState(function (_ref5) {
          var selectedIndex = _ref5.selectedIndex;
          return {
            selectedIndex: selectedIndex === 0 ? 0 : selectedIndex - 1
          };
        });
      } else if ((0, _KeyboardUtils.isArrowDown)(keyCode)) {
        /* istanbul ignore next */
        _this.setState(function (_ref6) {
          var results = _ref6.results,
              selectedIndex = _ref6.selectedIndex;
          return {
            selectedIndex: selectedIndex === results.length - 1 ? results.length - 1 : selectedIndex + 1
          };
        });
      } else
        /* istanbul ignore next */
        if ((0, _KeyboardUtils.isEnter)(keyCode)) {
          var _this$state = _this.state,
              results = _this$state.results,
              selectedIndex = _this$state.selectedIndex;
          var result = results[selectedIndex];

          if (result) {
            _this._resultClicked(result);
          } else {
            _this._resetSearch();
          }
        }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onValueChange", function (query) {
      var resultsFromStore = query.length >= _this.props.searchBuffer ? _this.checkForMatch(query) : [];

      _this.setState({
        results: resultsFromStore,
        selectedIndex: 0,
        query: query
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_resultClicked", function (result) {
      var onResultClick = _this.props.onResultClick;

      _this._resetSearch();
      /* istanbul ignore next */


      if (onResultClick) {
        onResultClick(result);
      }
    });

    _this.createSearchAndIndex(_props);

    _this.state = {
      query: null,
      results: _this.getInitialResults(),
      selectedIndex: 0
    };
    return _this;
  }

  (0, _createClass2.default)(KeywordSearch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref7) {
      var prevNavTree = _ref7.navTree;

      if (prevNavTree !== this.props.navTree) {
        this.createSearchAndIndex(this.props);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          dataId = _this$props["data-id"],
          title = _this$props.title,
          _this$props$initialTi = _this$props.initialTitle,
          initialTitle = _this$props$initialTi === void 0 ? title : _this$props$initialTi;
      return /*#__PURE__*/_react.default.createElement(_KeywordSearchView.default, {
        className: className,
        "data-id": dataId,
        onKeyDown: this._onKeyDown,
        onResultClick: this._resultClicked,
        onResultRender: this._onResultRender,
        onValueChange: this._onValueChange,
        queryString: this.state.query,
        results: this.state.results,
        selectedIndex: this.state.selectedIndex,
        title: this.state.query === null ? initialTitle : title
      });
    }
  }]);
  return KeywordSearch;
}(_react.default.Component);

exports.default = KeywordSearch;
(0, _defineProperty2.default)(KeywordSearch, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  initialResults: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  onResultClick: _propTypes.default.func,
  searchBuffer: _propTypes.default.number,
  sort: _propTypes.default.func,
  title: _propTypes.default.node,
  tree: _propTypes.default.arrayOf(_propTypes.default.shape({
    children: _propTypes.default.array,
    id: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  })).isRequired
});
(0, _defineProperty2.default)(KeywordSearch, "defaultProps", {
  "data-id": "keyword-search",
  searchBuffer: 0,
  sort: defaultSort
});